import React from 'react';
import cx from 'classnames';
import { COPY_STRINGS } from '../../../constants/translatedCopy';
import { aosTaskTypes } from '../../../constants/constants';
import { logSessionInfo } from '../../../services/logger';

export default class SplitItem extends React.Component {
  
  componentDidMount() {
    if (this.props.type === aosTaskTypes.beginningLetterSound) {
      console.warn("No image data found for beginning letter sound for word", this.props.left);
      logSessionInfo('no_image_data_found_for_beginning_letter_sound', { word: this.props.left });
    }
  }

  render() {
    let containerClasses = cx({
      'exampleItemContainer': this.props.isInstruction,
      'splitItemContainer': true,
      'testItemContainer': true,
    });

    let wordContainerClasses = cx({
      'example': this.props.isInstruction,
      'splitItem' : true,
      'outlined' : true,
    });

    const leftItemClasses = cx({
      'leftItem': true,
      'noFloatLeft': this.props.type === aosTaskTypes.beginningLetterSound,
    });

    return (
      <div className={containerClasses}>
        {this.props.isInstruction && <div className="exampleIndicator">{COPY_STRINGS.example}:</div>}
        <div className={wordContainerClasses}>
          <div className={leftItemClasses}>{this.props.left}</div>
          <div className="rightItem">{this.props.right}</div>
        </div>
      </div>
    );
  }
}
